import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Box, CircularProgress } from "@mui/material";
import ApiService from "../../Frontend/Api/ApiServices";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  address: Yup.string().required("Address is required"),
  contact: Yup.string()
    .required("Contact number is required")
    .matches(/^[0-9]+$/, "Contact number must contain only digits"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  comments: Yup.string().required("Comments are required"),
});

function ContactUs() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ success: false, error: false });

  const handleSubmit = async (values, { resetForm }) => {
    setIsSubmitting(true);
    try {
      const response = await ApiService.submitContactForm(values);
      if (response.data) {
        setSubmitStatus({ success: true, error: false });
        resetForm();
      }
    } catch (error) {
      setSubmitStatus({ success: false, error: true });
      console.error("Error submitting form:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (submitStatus.success) {
     setTimeout(() => {
      setSubmitStatus({ success: false, error: false });
     }, 3000);
    }
  }, [submitStatus]);

  return (
    <div id="home-video-main">
      <section className="contact-shortly">
        <h6 className="shortly-title">We will get in touch shortly</h6>
        <Formik
          initialValues={{
            name: "",
            address: "",
            contact: "",
            email: "",
            comments: "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, errors, touched, handleChange, handleBlur }) => (
            <Form className="show-form-grop">
              <div className="form-control-comments">
                <label className="show-form-title" htmlFor="name">
                  Name
                </label>
                <div className="input-icon">
                  <input
                    id="name"
                    className={`form-control show-form-control ${
                      touched.name && errors.name ? "is-invalid" : ""
                    }`}
                    type="text"
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {touched.name && errors.name && (
                    <div className="invalid-feedback">{errors.name}</div>
                  )}
                </div>
              </div>

              <div className="form-control-comments">
                <label className="show-form-title" htmlFor="address">
                  Address
                </label>
                <div className="input-icon">
                  <input
                    id="address"
                    className={`form-control show-form-control ${
                      touched.address && errors.address ? "is-invalid" : ""
                    }`}
                    type="text"
                    name="address"
                    value={values.address}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.address && errors.address}
                   
                  />
                  {touched.address && errors.address && (
                    <div className="invalid-feedback ">{errors.address}</div>
                  )}
                </div>
              </div>

              <div className="form-control-comments">
                <label className="show-form-title" htmlFor="contact">
                  Contact no
                </label>
                <div className="input-icon">
                  <input
                    id="contact"
                    className={`form-control show-form-control ${
                      touched.contact && errors.contact ? "is-invalid" : ""
                    }`}
                    type="text"
                    name="contact"
                    value={values.contact}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {touched.contact && errors.contact && (
                    <div className="invalid-feedback">{errors.contact}</div>
                  )}
                </div>
              </div>

              <div className="form-control-comments">
                <label className="show-form-title" htmlFor="email">
                  Email
                </label>
                <div className="input-icon">
                  <input
                    id="email"
                    className={`form-control show-form-control ${
                      touched.email && errors.email ? "is-invalid" : ""
                    }`}
                    type="email"
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {touched.email && errors.email && (
                    <div className="invalid-feedback">{errors.email}</div>
                  )}
                </div>
              </div>

              <div className="form-control-comments">
                <label className="show-form-title" htmlFor="comments">
                  Questions/Comments
                </label>
                <div className="input-icon">
                  <textarea
                    id="comments"
                    className={`form-control emergency-input show-form-textarea ${
                      touched.comments && errors.comments ? "is-invalid" : ""
                    }`}
                    rows="9"
                    name="comments"
                    value={values.comments}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  ></textarea>
                  {touched.comments && errors.comments && (
                    <div className="invalid-feedback">{errors.comments}</div>
                  )}
                </div>
              </div>

              <div className="show-form-button">
                <button
                  className="btn-green-contact"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <CircularProgress size={20} color="inherit" />
                      Submitting...
                    </Box>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>

              {submitStatus.success && (
                <div className="alert alert-success mt-3 text-center text-success">
                  Thank you for your message! We will get back to you shortly.
                </div>
              )}
              {submitStatus.error && (
                <div className="alert alert-danger mt-3 invalid-feedback text-center">
                  There was an error submitting your message. Please try again.
                </div>
              )}
            </Form>
          )}
        </Formik>
      </section>
    </div>
  );
}

export default ContactUs;
